// Translations
export const T = {
  en_GB: {
    postComment: "Post comment",
    title: "Ideas",
    subtitle: "Share feedback and vote on ideas",
    submitIdea: "Submit Idea",
    titleLabel: "Title",
    titlePlaceholder: "Brief summary",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Describe your idea...",
    areaLabel: "Area",
    selectArea: "Select area",
    englishNotice:
      "Ideas are shared in English. Write in any language — it is translated for you on save.",
    cancel: "Cancel",
    submit: "Submit",
    noIdeas: "No ideas yet. Be the first!",
    loading: "Loading...",
    back: "Back",
    votes: "votes",
    comments: "Comments",
    noComments: "No comments yet",
    addComment: "Add a comment...",
    send: "Send",
    delete: "Delete",
    confirmDelete: "Delete this idea?",
    confirmDeleteComment: "Delete this comment?",
    status: "Status",
    sortTop: "Top",
    sortNewest: "Newest",
    filterAll: "All",
    // Areas
    docs: "Docs",
    ai_agent: "AI Agent",
    flow_management: "Flows",
    portfolios: "Portfolios",
    risk_models: "Risk",
    pdf_templates: "PDF",
    clients: "Clients",
    settings: "Settings",
    other: "Other",
    // Statuses
    idea: "Idea",
    considering: "Considering",
    implementing: "Implementing",
    done: "Done",
    rejected: "Rejected",
    // Image
    imageLabel: "Screenshot",
    screenshotPreview: "Screenshot preview",
    imageHint: "PNG, JPG (max 2MB)",
    removeImage: "Remove",
    // Errors
    loadFailed: "Failed to load ideas",
    genericError: "Something went wrong",
    selectImageFile: "Please select an image file",
    imageTooLarge: "Image must be less than 2MB",
    uploadFailed: "Failed to upload image",
  },
  nb_NO: {
    postComment: "Publiser kommentar",
    title: "Ideer",
    subtitle: "Del tilbakemeldinger og stem på ideer",
    submitIdea: "Send inn idé",
    titleLabel: "Tittel",
    titlePlaceholder: "Kort sammendrag",
    descriptionLabel: "Beskrivelse",
    descriptionPlaceholder: "Beskriv ideen din...",
    areaLabel: "Område",
    selectArea: "Velg område",
    englishNotice:
      "Ideer deles på engelsk. Skriv på språket du vil — det oversettes for deg når du lagrer.",
    cancel: "Avbryt",
    submit: "Send inn",
    noIdeas: "Ingen ideer ennå. Vær den første!",
    loading: "Laster...",
    back: "Tilbake",
    votes: "stemmer",
    comments: "Kommentarer",
    noComments: "Ingen kommentarer ennå",
    addComment: "Legg til en kommentar...",
    send: "Send",
    delete: "Slett",
    confirmDelete: "Slette denne ideen?",
    confirmDeleteComment: "Slette denne kommentaren?",
    status: "Status",
    sortTop: "Topp",
    sortNewest: "Nyeste",
    filterAll: "Alle",
    // Areas
    docs: "Docs",
    ai_agent: "AI Agent",
    flow_management: "Flyter",
    portfolios: "Porteføljer",
    risk_models: "Risiko",
    pdf_templates: "PDF",
    clients: "Kunder",
    settings: "Innstillinger",
    other: "Annet",
    // Statuses
    idea: "Idé",
    considering: "Vurderer",
    implementing: "Implementerer",
    done: "Ferdig",
    rejected: "Avvist",
    // Image
    imageLabel: "Skjermbilde",
    screenshotPreview: "Forhåndsvisning av skjermbilde",
    imageHint: "PNG, JPG (maks 2MB)",
    removeImage: "Fjern",
    // Errors
    loadFailed: "Kunne ikke laste ideer",
    genericError: "Noe gikk galt",
    selectImageFile: "Velg en bildefil",
    imageTooLarge: "Bildet må være mindre enn 2MB",
    uploadFailed: "Kunne ikke laste opp bildet",
  },
} as const;
